import React, { useState } from "react";
import axios from "axios";
import API_URL from "../../Config";
import { IoClose } from "react-icons/io5";
import "./customer.css"; // ✅ import new css

const AddCustomerPopup = ({ onClose, onSuccess, showSnackbar }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [customerData, setCustomerData] = useState({
    sap_code: "",
    customer_name: "",
    customer_type: "",
    email: "",
    contact_number: "",
    billing_address_line1: "",
    billing_address_line2: "",
    billing_city: "",
    billing_state: "",
    billing_pincode: "",
    shipping_address_line1: "",
    shipping_address_line2: "",
    shipping_city: "",
    shipping_state: "",
    shipping_pincode: "",
  });

  const [errors, setErrors] = useState({});

  const customerTypeOptions = [
    "Defence",
    "Government",
    "Retail Outlet",
    "Private",
  ];

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setCustomerData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateContactNumber = (number) => /^[0-9]{10}$/.test(number);

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!customerData.customer_name.trim()) {
      newErrors.customer_name = "Customer name is required";
      isValid = false;
    }
    // if (!customerData.contact_number.trim()) {
    //   newErrors.contact_number = "Contact number is required";
    //   isValid = false;
    // }
    //  else if (!validateContactNumber(customerData.contact_number)) {
    //   newErrors.contact_number = "Contact number must be 10 digits";
    //   isValid = false;
    // }
    if (!customerData.sap_code.trim()) {
      newErrors.sap_code = "SAP code is required";
      isValid = false;
    }
    if (!customerData.customer_type.trim()) {
      newErrors.customer_type = "Customer type is required";
      isValid = false;
    }
    if (customerData.email && !validateEmail(customerData.email)) {
      newErrors.email = "Please enter a valid email";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSaveClick = async () => {
    if (!validateForm()) {
      showSnackbar("Please fill all required fields correctly");
      return;
    }

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.post(
        `${API_URL}/api/barrel/customers`,
        customerData,
        { headers: { Authorization: authKey } }
      );

      if (response.status === 201) {
        showSnackbar("Customer added successfully");
        onSuccess();
      }
    } catch (error) {
      console.error("Error saving customer:", error);
      if (error.response?.status === 409) {
        showSnackbar("Customer with this SAP code already exists");
      } else {
        showSnackbar("Error saving customer");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="barrels_popup-overlay">
      <div className="barrels_popup-modal">
        <div className="barrels_popup-header">
          <h4>Add New Customer</h4>
          <span className="barrels_close-btn" onClick={onClose}>
            <IoClose />
          </span>
        </div>

        <div className="barrels_popup-body_content">
          <div className="barrels_popup-body">
            <form>
              {/* Customer Name */}
              <div className="barrels_form-group">
                <label>
                  Customer Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="customer_name"
                  value={customerData.customer_name}
                  onChange={handleInputChange}
                  placeholder="Enter customer name"
                />
                {errors.customer_name && (
                  <span className="barrels_error">{errors.customer_name}</span>
                )}
              </div>

              {/* Contact Number */}
              <div className="barrels_form-group">
                <label>Contact Number</label>
                <input
                  type="text"
                  name="contact_number"
                  value={customerData.contact_number}
                  onChange={handleInputChange}
                  placeholder="Enter 10-digit contact number"
                  maxLength="10"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) e.preventDefault();
                  }}
                />
              </div>

              {/* Email */}
              <div className="barrels_form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={customerData.email}
                  onChange={handleInputChange}
                  placeholder="Enter email address"
                />
                {errors.email && (
                  <span className="barrels_error">{errors.email}</span>
                )}
              </div>

              {/* SAP Code */}
              <div className="barrels_form-group">
                <label>
                  SAP Code (Vendor Code)<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="sap_code"
                  value={customerData.sap_code}
                  onChange={handleInputChange}
                  placeholder="Enter SAP code"
                />
                {errors.sap_code && (
                  <span className="barrels_error">{errors.sap_code}</span>
                )}
              </div>

              {/* Customer Type */}
              <div className="barrels_form-group">
                <label>
                  Customer Type<span className="text-danger">*</span>
                </label>
                <select
                  name="customer_type"
                  value={customerData.customer_type}
                  onChange={handleInputChange}
                >
                  <option value="">Select customer type</option>
                  {customerTypeOptions.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                {errors.customer_type && (
                  <span className="barrels_error">{errors.customer_type}</span>
                )}
              </div>

              {/* Billing Address */}
              <div className="barrels_address-section">
                <h5>Billing Address</h5>
                <div className="barrels_address-row">
                  <input
                    type="text"
                    name="billing_address_line1"
                    placeholder="Address Line 1"
                    value={customerData.billing_address_line1}
                    onChange={handleInputChange}
                  />
                  <input
                    type="text"
                    name="billing_address_line2"
                    placeholder="Address Line 2"
                    value={customerData.billing_address_line2}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="barrels_address-row">
                  <input
                    type="text"
                    name="billing_city"
                    placeholder="City"
                    value={customerData.billing_city}
                    onChange={handleInputChange}
                  />
                  <input
                    type="text"
                    name="billing_state"
                    placeholder="State"
                    value={customerData.billing_state}
                    onChange={handleInputChange}
                  />
                  <input
                    type="text"
                    name="billing_pincode"
                    placeholder="Pincode"
                    value={customerData.billing_pincode}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* Shipping Address */}
              <div className="barrels_address-section">
                <h5>Shipping Address</h5>
                <div className="barrels_address-row">
                  <input
                    type="text"
                    name="shipping_address_line1"
                    placeholder="Address Line 1"
                    value={customerData.shipping_address_line1}
                    onChange={handleInputChange}
                  />
                  <input
                    type="text"
                    name="shipping_address_line2"
                    placeholder="Address Line 2"
                    value={customerData.shipping_address_line2}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="barrels_address-row">
                  <input
                    type="text"
                    name="shipping_city"
                    placeholder="City"
                    value={customerData.shipping_city}
                    onChange={handleInputChange}
                  />
                  <input
                    type="text"
                    name="shipping_state"
                    placeholder="State"
                    value={customerData.shipping_state}
                    onChange={handleInputChange}
                  />
                  <input
                    type="text"
                    name="shipping_pincode"
                    placeholder="Pincode"
                    value={customerData.shipping_pincode}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="barrels_popup-footer">
          <button
            className="barrels_btn barrels_btn-save"
            onClick={handleSaveClick}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </button>
          <button
            className="barrels_btn barrels_btn-cancel"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCustomerPopup;
